/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_ActorInputs */

const cs_audit_actor = /** @type {(inputs: Audit_ActorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktér`)
};

const en_audit_actor = /** @type {(inputs: Audit_ActorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actor`)
};

/**
* | output |
* | --- |
* | "Actor" |
*
* @param {Audit_ActorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_actor = /** @type {((inputs?: Audit_ActorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_ActorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_actor(inputs)
	return cs_audit_actor(inputs)
});